import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, Typography } from "@material-ui/core";
import { SectionDefinition } from "api/factories/form.factory";
import { SectionDefinitionValue } from "components/SchemaProvider";
import { TextField as AdTextField } from "components";

export const TextField = ({ name, translation, value }: SectionDefinition<SectionDefinitionValue>) => {
    const { control, errors } = useFormContext();

    return (
        <FormControl fullWidth={true}>
            <Controller
                defaultValue={value}
                name={name}
                control={control}
                error={!!errors[name]}
                label={translation}
                as={<AdTextField />}
            />
            {errors[name] && (
                <Typography variant="body1" color="error">
                    {errors[name].message}
                </Typography>
            )}
        </FormControl>
    );
};
